import React, { Component } from "react";
import TopicData from './topic-data';
import { withLocalize } from "react-localize-redux";
import "./style.scss";
import PopupFilter from "../popup-filter";
import PopupChartSetting from "../popup-chart-setting";

class PlayerAddTopic extends Component {
    constructor() {
        super();
        this.state = {
            showPopupFilter: false,
            showPopupChartSetting: false,
            showOption: false,
            valueOption: '作業中',
            topics: [],
            isShowDrop  :true
        };
    }

    showOption = () => {
        this.setState({
            showOption: !this.state.showOption,
        })
    }

    selectOption = (e) => {
        let target = document.getElementById('option-selected');
        let element = e.target;
        target.innerHTML = this.nodeToString(element);
        this.setState({
            valueOption: element.innerHTML,
        })
    }
    nodeToString = node => {
        let tmpNode = document.createElement("div");
        tmpNode.appendChild(node.cloneNode(true));
        let str = tmpNode.innerHTML;
        tmpNode = node = null;
        return str;
    }

    allowDrop = (e) => {
        e.preventDefault();
    }

    drop = (e) => {
        e.preventDefault();
        let data = e.dataTransfer.getData("text");
        // e.target.appendChild(document.getElementById(data));
        // e.target.removeChild(document.getElementById(data));
        if (this.state.topics.length === 9) {
            this.setState({ 
              topics: [...this.state.topics, {name: document.getElementById(data).innerText}],
              isShowDrop : false
            });
          } else {
            this.setState({ 
              topics: [...this.state.topics, {name: document.getElementById(data).innerText}] 
            });
          }
        
    }

    itemTopics = () => {
        if (this.state.topics) {
            return this.state.topics.map((topic, index) => {
                return <div className="block-item" key={index}>
                    <span>{topic.name}</span>
                </div>
            })
        }
    }

    togglePopupFilter = () => {
        this.setState({
            showPopupFilter: !this.state.showPopupFilter
        })
    }

    togglePopupChartSetting = () => {
        this.setState({
            showPopupChartSetting: !this.state.showPopupChartSetting
        })
    }

    render() {
        return (
            <div className="add-topic">
                <div className="block-control">
                    <div className="form-control" onClick={this.showOption}>
                        <div id="option-selected">
                            <div className="option-1">{this.state.valueOption}</div>
                        </div>
                        {this.state.showOption ?
                            <div>
                                <div className="option option-1" onClick={this.selectOption} >作業中</div>
                                <div className="option option-2" onClick={this.selectOption} >作業完了</div>
                                <div className="option option-3" onClick={this.selectOption} >チェック済</div>
                            </div> : null}
                    </div>

                    <div className="block-button">
                        <button type="button" className="btn-delete">Topicsを削除</button>
                        <button type="button" className="btn-copy">Topicsをコピー</button>
                    </div>
                </div>

                <div className="block-content"  >
                    {this.itemTopics()}
                    {
                        this.state.isShowDrop
                            ? <div className="block-item" id="drop" onDrop={this.drop} onDragOver={this.allowDrop}>
                            <img src="/img/content/add_24px.svg" alt="" />
                            <span>データプールからドラッグ&ドロップで追加</span>
                        </div>
                        : null
                    }
                    
                </div>
                <TopicData />

                {this.state.showPopupFilter ?
                    <PopupFilter closePopup={this.togglePopupFilter} />
                    : null
                }

                {this.state.showPopupChartSetting ?
                    <PopupChartSetting closePopup={this.togglePopupChartSetting} />
                    : null
                }

                <div className="block-button">
                    <button type="button" onClick={this.togglePopupFilter}>Open Popup Filter</button>
                    <button type="button" onClick={this.togglePopupChartSetting}>Open Popup Chart Setting</button>
                </div>
            </div>
        )
    }
}

export default withLocalize(PlayerAddTopic);